import React from 'react';
import css from './styles.module.scss';
import { Typography } from '@material-ui/core';
import { Control, Controller, FieldError } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import { ParsableDate } from '@material-ui/pickers/constants/prop-types';
import moment from 'moment';
import { DesktopDatePicker, LocalizationProvider } from '@material-ui/pickers-next';

import MomentUtilsNext from '@material-ui/pickers-next/adapter/moment';
import classNames from "classnames";
import { useDateFormat } from '~/common/date-format';

interface DatePickerControllerProps {
    error?: FieldError;
    control: Control;
    name: string;
    label: string;
    minDate?: ParsableDate;
    maxDate?: ParsableDate;
    row?: boolean;
    defaultValue?: any;
    className?: any;
}

export const DatePickerController: React.FC<DatePickerControllerProps> = ({ name, error, control, label, minDate, maxDate, row, defaultValue, className }) => {
    const { selectedDateFormat } = useDateFormat();
    return (
        <>
            <LocalizationProvider dateAdapter={MomentUtilsNext}>
                <div className={classNames(className, (row ? css.block : css.module))}>
                    {row ? (
                        <Typography className={css.fieldName} style={label.length > 0 ? { marginTop: '15px' } : {}}>
                            {label}
                        </Typography>
                    ) : (
                        <Typography variant="h6" className={css.fieldName}>
                            {label}:
                        </Typography>
                    )}
                    <Controller
                        defaultValue={defaultValue ? moment(defaultValue) : null}
                        // rules={{ required: `${label} is required` }}
                        render={controllerProps => (
                            <DesktopDatePicker
                                {...controllerProps}
                                onChange={newValue => controllerProps.onChange(moment(newValue).format() || null)}
                                value={controllerProps.value ? moment(controllerProps.value) : null}
                                inputFormat={selectedDateFormat}
                                minDate={minDate ? moment(minDate) : undefined}
                                maxDate={maxDate ? moment(maxDate) : undefined}
                                renderInput={(props: any) => (
                                    <TextField
                                        {...props}
                                        className={row ? css.inputblock : css.input}
                                        error={!!error}
                                        helperText={error?.message}
                                        variant="filled"
                                    />
                                )}
                            />
                        )}
                        name={name}
                        control={control}
                    />
                </div>
                {row ? (
                    ''
                ) : (
                    <div style={{ display: 'flex', width: '100%' }}>
                        <div style={{ minWidth: '170px' }} />
                        <Typography style={{ fontSize: '0.8rem', color: '#00000073', marginTop: '-0.8rem' }}>MM/DD/YYY</Typography>
                    </div>
                )}
            </LocalizationProvider>
        </>
    );
};
